export default __webpack_public_path__ + "static/event-78108b3e59afd246d63e3884e0222ea5.png";